import React from "react";
import {
  Alert,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import SelectGender from "./SelectGender";

const PaymentForm: React.FC<{
  toggle: () => void;
  loading: boolean;
  isUpdate?: boolean;
  validation: any;
  fieldErrors: any[];
}> = ({ validation, toggle, isUpdate, loading, fieldErrors }) => {
  return (
    <Form
      className="tablelist-form"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <ModalBody>
        <input type="hidden" id="id-field" />

        {fieldErrors.length > 0 && (
          <div className="mb-3">
            <Alert color="danger" className="material-shadow">
              {fieldErrors.map((error: any, index: any) => (
                <div key={index}>
                  <strong>{error.field}:</strong> {error.message}
                </div>
              ))}
            </Alert>
          </div>
        )}

        <div className="mb-3">
          <Label htmlFor="id-field" className="form-label">
            Full Name
          </Label>
          <Input
            name="fullName"
            id="fullName"
            className="form-control"
            placeholder="Enter full name"
            type="text"
            validate={{
              required: { value: true },
            }}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.fullName || ""}
            invalid={
              validation.touched.fullName && validation.errors.fullName
                ? true
                : false
            }
          />
          {validation.touched.fullName && validation.errors.fullName ? (
            <FormFeedback type="invalid">
              {validation.errors.fullName}
            </FormFeedback>
          ) : null}
        </div>

        <Row>
          <Col md={6} className="mb-3">
            <SelectGender validation={validation} />
          </Col>
          <Col md={6} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Passport or ID Number
            </Label>
            <Input
              name="passportOrIdNumber"
              id="passportOrIdNumber"
              className="form-control"
              placeholder="Enter project or fund"
              type="text"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.passportOrIdNumber || ""}
              invalid={
                validation.touched.passportOrIdNumber &&
                validation.errors.passportOrIdNumber
                  ? true
                  : false
              }
            />
            {validation.touched.passportOrIdNumber &&
            validation.errors.passportOrIdNumber ? (
              <FormFeedback type="invalid">
                {validation.errors.passportOrIdNumber}
              </FormFeedback>
            ) : null}
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Email Address
            </Label>
            <Input
              name="emailAddress"
              id="emailAddress"
              className="form-control"
              placeholder="Enter email address"
              type="text"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.emailAddress || ""}
              invalid={
                validation.touched.emailAddress &&
                validation.errors.emailAddress
                  ? true
                  : false
              }
            />
            {validation.touched.emailAddress &&
            validation.errors.emailAddress ? (
              <FormFeedback type="invalid">
                {validation.errors.emailAddress}
              </FormFeedback>
            ) : null}
          </Col>
          <Col md={6} className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              Phone Number
            </Label>
            <Input
              name="phoneNumber"
              id="phoneNumber"
              className="form-control"
              placeholder="Enter phone number"
              type="text"
              validate={{
                required: { value: true },
              }}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.phoneNumber || ""}
              invalid={
                validation.touched.phoneNumber && validation.errors.phoneNumber
                  ? true
                  : false
              }
            />
            {validation.touched.phoneNumber && validation.errors.phoneNumber ? (
              <FormFeedback type="invalid">
                {validation.errors.phoneNumber}
              </FormFeedback>
            ) : null}
          </Col>
        </Row>
      </ModalBody>

      <div className="modal-footer">
        <div className="hstack gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              toggle();
            }}
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading && (
              <Spinner
                color="light"
                size="sm"
                style={{ marginRight: "8px", marginBottom: "-1px" }}
              ></Spinner>
            )}
            {isUpdate ? "Update Individual" : "Add Individual"}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default PaymentForm;
